$ = jQuery;

$(document).ready(function(){
//accordion
var acc = document.getElementsByClassName("acc-head");
	var i;
	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function () {
			this.classList.toggle("active");
			var panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
		});
	}
//accordion ends

    if ($('form').length) {
        $('form').validate({
            highlight: function(element, errorClass, validClass) {
                $(element).addClass(errorClass).removeClass(validClass);
                $(element).parent().addClass(errorClass).removeClass(validClass);
            },

            unhighlight: function(element, errorClass, validClass) {
                $(element).removeClass(errorClass).addClass(validClass);
                $(element).parent().removeClass(errorClass).addClass(validClass);
            },
            onfocusout: function(element) {
                $(element).valid();
            },
            onkeyup: false
        });

    }
	
	
	
    var $prev, $next;

    $('.testimonials-slider').each(function() {
        $prev = $(this).parent().find('.prev');
        $next = $(this).parent().find('.next');
        $(this).slick({
            dots: false,
            prevArrow: $prev,
            nextArrow: $next,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true
        });
    });


});
